// Dynamic.
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL as string;
export const ADMIN_BASE_URL = process.env.REACT_APP_ADMIN_BASE_URL;
export const AD_ADMIN_APP_CLIENT_ID = process.env.REACT_APP_AD_ADMIN_APP_CLIENT_ID;
export const AD_ADMIN_API_AUDIENCE = process.env.REACT_APP_AD_ADMIN_API_AUDIENCE;
export const ALLOW_TEST_FEATURES = process.env.REACT_APP_ALLOW_TEST_FEATURES === "true";

// Static.
export const ARM_TENANT_ID = "4316fc9e-10e8-4ef9-91cd-2c1e35c2879f";
